import React, { useMemo, Fragment, useState, useEffect } from 'react';
import MpgInput from "../../../../CommonFormComp/MpgInput";
import { useForm, SubmitHandler } from "react-hook-form"
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import { Link } from "react-router-dom";
import Typography from '@mui/material/Typography';
import { styled } from '@mui/material/styles';
import Paper from '@mui/material/Paper';
import Button from '@mui/material/Button';
import AddBioDialog from '../AddBioDialog';
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import MpgFileUpload from '../../../../fileHandling/MpgFileUpload';
import { useCreateTeamMemberMutation, useUploadProfilePicOfTeamMemberMutation } from '../../../../reactQueries/AppApi/rqHooksForAccountTeamMembers';
import { useNavigate } from "react-router-dom";
import Stack from "@mui/material/Stack";
import BioTable from "../BioTable";
import EditBioDialog from "../EditBioDialog";
import { accountTeamMemberViewPath } from "../../../../routes/routePaths";
import MpgErrorDialog from "../../../../common/dialog/MpgErrorDialog";
import MpgLoadingDialog from "../../../../common/dialog/MpgLoadingDialog";
import useTrackUserActivity from "../../../../userActivityTracking/useTrackUserActivity";
import { getGUIDAndExtentionFromFileURL } from "../../../../hooksAndFunctions/functions/getGUIDAndExtentionFromFileURL";
import { useGetSiteCoreCMSData } from '../../../../reactQueries/commonRQHooks';

const Item = styled(Paper)(({ theme }) => ({
    backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#fff',
    ...theme.typography.body2,
    padding: theme.spacing(1),
    textAlign: 'center',
    color: theme.palette.text.secondary,
}));

const CreateAccountTeamMembers = () => {
    let navigate = useNavigate();

    const userName = JSON.parse(window.sessionStorage.getItem('UserAccount'))?.["name"];

    /**bio handling */
    const [bioDetailTableData, setBioDetailTableData] = useState([])

    // console.log("abc:", bioDetailTableData)

    /**API calls to CreateTeamMember */
    const { mutate: createTeamMember, isError: isErrorOnCreate, isLoading: isLoadingOnCreate, isSuccess: isSuccessOnCreate, data: dataOnCreate, error: errorOnCreate } = useCreateTeamMemberMutation()

    const { mutate: uploadProfilePic, isError: isErrorOnProfilePicUpload, isLoading: isLoadingOnProfilePicUpload, isSuccess: isSuccessOnProfilePicUpload, data: dataOnProfilePicUpload, error: errorOnProfilePicUpload } = useUploadProfilePicOfTeamMemberMutation()

    const { isSuccess: isSuccessOnSiteCoreCMS, error: errorOnSiteCoreCMS, data: adminAccountCMSDataFromAPI, isError: isErrorOnSiteCoreCMS, isFetching: isFetchingOnSiteCoreCMS } = useGetSiteCoreCMSData({ pagename: "AccountTeam" });

    const [adminAccountTeamCMSData, setAdminAccountTeamCMSData] = useState({ title: "", description: "", tabNavigationTitle: "", pageContent: {} });

    //#region  CMS Content hadling

    const fetchAdminAccountTeamCMSData = () => {
        if (adminAccountCMSDataFromAPI && adminAccountCMSDataFromAPI?.Pages) {
            adminAccountCMSDataFromAPI.Pages.map((el) => {
                if (el.Key === "AccountTeam") {
                    const { Title, Description, TabNavigationTitle, Components } = el;
                    setAdminAccountTeamCMSData({ title: Title, description: Description, tabNavigationTitle: TabNavigationTitle, pageContent: Components });
                }
            });
        }
    }

    useEffect(() => {
        fetchAdminAccountTeamCMSData();
    }, [adminAccountCMSDataFromAPI])

    const fetchAdminAccountTeamDetailsLabel = (key) => {
        if (adminAccountTeamCMSData && adminAccountTeamCMSData?.pageContent["AccountTeamMemberDetailsComponent"]) {
            const adminAccountCMSDataLabel = adminAccountTeamCMSData.pageContent["AccountTeamMemberDetailsComponent"];
            return returnLabel(adminAccountCMSDataLabel?.Labels, key)
        }
        return '';
    }

    const returnLabel = (labelArray=[], key) => {
            return labelArray.find((x) => x.Key === key)?.Phrase || '';
    }
    // #endregion

    /**form handling */

    const schema = yup.object().shape({
        first_name: yup.string().label('This field').required().max(100),
        last_name: yup.string().label('This field').required().max(100),
        email: yup.string().label('This field').email().required().max(200),
        job_title: yup.string().label('This field').required().max(200),
        contact_no: yup.string().optional()
            .test("mobileNoValidation", fetchAdminAccountTeamDetailsLabel('AccountTeamMemberDetails.ValidationMsgForMobileNumber'), (string) => {
                //const regex = /^[+][1-9][0-9]{7,14}$/
                const regex = /^\+[0-9](?:[\s\-]?[0-9]){7,18}$/
                return !string || (!!string && string.search(regex) !== -1)
            }),
        profileImg: yup.mixed().optional()
            .test("fileTypeValidation",fetchAdminAccountTeamDetailsLabel('AccountTeamMemberDetails.ValidationMsgforUploadFileType'), (file) => {
                // console.log("gl-validate:", file)
                const fileTypeList = ["image/jpeg", "image/jpg", "image/png"]
                //if u want to allow only certain file types only

                return !file[0] || (!!file[0] && fileTypeList.includes(file[0].type))
            })
            .test("fileSizeValidation", fetchAdminAccountTeamDetailsLabel('AccountTeamMemberDetails.ValidationMsgforUploadFileSize'), (file) => {
                // console.log("gl-validate:", file)
                //if u want to allow only certain file sizes
                return !file[0] || (!!file[0] && file[0].size <= 1 * 1024 * 1024)
            })
    });
    const rhfFormInstance = useForm({
        resolver: yupResolver(schema)
    });
    const { watch } = rhfFormInstance

    const [bodyDataCreate, setBodyDataCreate] = useState({})
    const onSubmit = (data) => {
        let listOfNewlyAddedBios = []
        /**grab only newly added bio details which are marked by flag === "notFromDB" */

        if (!!bioDetailTableData.length) {
            bioDetailTableData.forEach((item) => {
                /**removing Id and flag properties */
                if (item?.flag === "notFromDB") {
                    const newEntry = {
                        Content: item?.Content,
                        IsActive: item?.IsActive,
                        LanguageDescription: item?.LanguageDescription,
                        LanguageId: item?.LanguageId,
                        LanguageCode: item?.LanguageCode,
                        TemplateTitle: item?.TemplateTitle,
                        CreatedBy: userName
                    }
                    /**after removving properties pushing */
                    listOfNewlyAddedBios.push(newEntry)
                }
            })
        }

        const body = {
            FirstName: data.first_name || '',
            LastName: data.last_name || '',
            EmailAddress: data.email || '',
            ContactNo: data.contact_no || '',
            JobPosition: data.job_title || '',
            ProfilePhotoURL: '',
            IsActive: true,
            CreatedBy: userName || '',
            BioDetail: listOfNewlyAddedBios || []
        }

        setBodyDataCreate(body)

        if (!!data.profileImg[0]) {
            const file = data.profileImg[0]
            uploadProfilePic({ file })
        } else {
            createTeamMember({ body })
        }
    }

    useEffect(() => {
        if (!!isSuccessOnProfilePicUpload) {

            const storedFileURL = dataOnProfilePicUpload?.data?.FileUrl
            const bodyData = {
                ...bodyDataCreate,
                ProfilePhotoURL: storedFileURL
            }
            createTeamMember({ body: bodyData })
        }
    }, [isSuccessOnProfilePicUpload])

    useEffect(() => {
        if (!!isSuccessOnCreate) {
            navigate(accountTeamMemberViewPath)
        }
    }, [isSuccessOnCreate])

    /**dialog handling for bios*/
    const [open, setOpen] = React.useState(false);

    /**dialog handling for bios Edit*/
    const [openEditBioDialog, setOpenEditBioDialog] = React.useState(false);
    const [bioDetailObjToBeEdited, setBioDetailObjToBeEdited] = React.useState({});

    /**tracking user Activity */
    const { trackActivity } = useTrackUserActivity()
    useEffect(() => {
        if (!!isSuccessOnProfilePicUpload) {
            const { fileGUID } = getGUIDAndExtentionFromFileURL({ fileURL: dataOnProfilePicUpload?.data?.FileUrl })

            trackActivity({
                activitySuccess: !!isSuccessOnProfilePicUpload,
                actionType: "Uploaded",
                itemId: fileGUID || "",
            })
        }
    }, [isSuccessOnProfilePicUpload])

    return (
        <Box sx={{ width: '100%' }}>
            <Typography variant="h5" align='center' sx={{ fontWeight: 'bolder' }}>
                {adminAccountTeamCMSData?.pageContent["AccountTeamMemberDetailsComponent"]?.Title}
            </Typography>
            <Stack
                direction={{ xs: "column", sm: "row" }}
                justifyContent="space-between"
                alignItems="center"
                spacing={1}
                m={1}
            >
                <Button
                    variant="outlined"
                    size="small"
                    component={Link}
                    to={accountTeamMemberViewPath}
                >{fetchAdminAccountTeamDetailsLabel('AccountTeamMemberDetails.AccountTeamMembers')}</Button>

                <Button
                    variant="outlined"
                    size="small"
                    disabled
                >{fetchAdminAccountTeamDetailsLabel('AccountTeamMemberDetails.RemoveTeamMember')}</Button>
            </Stack>

            <Box
                component="form"
                noValidate
                autoComplete="off"
                onSubmit={rhfFormInstance.handleSubmit(onSubmit)}
            >
                <Item>
                    <Typography variant="h6" align='left' sx={{ fontWeight: 'bolder' }}>
                        {fetchAdminAccountTeamDetailsLabel('AccountTeamMemberDetails.MemberDetailsHeading')}
                    </Typography>
                    <Grid container spacing={1}>

                        <Grid item xs={12} sm={6}>
                            <MpgInput
                                rhfFormInstance={rhfFormInstance}
                                name={'first_name'}
                                label={fetchAdminAccountTeamDetailsLabel('AccountTeamMemberDetails.FirstName')}
                                fullWidth
                            />
                        </Grid>

                        <Grid item xs={12} sm={6}>
                            <MpgInput
                                rhfFormInstance={rhfFormInstance}
                                name={'last_name'}
                                label={fetchAdminAccountTeamDetailsLabel('AccountTeamMemberDetails.LastName')}
                                fullWidth
                            />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <MpgInput
                                rhfFormInstance={rhfFormInstance}
                                name={'email'}
                                label={fetchAdminAccountTeamDetailsLabel('AccountTeamMemberDetails.Email')}
                                fullWidth
                            />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <MpgInput
                                rhfFormInstance={rhfFormInstance}
                                name={'job_title'}
                                label={fetchAdminAccountTeamDetailsLabel('AccountTeamMemberDetails.JobTitle')}
                                fullWidth
                            />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <MpgInput
                                rhfFormInstance={rhfFormInstance}
                                name={'contact_no'}
                                label={fetchAdminAccountTeamDetailsLabel('AccountTeamMemberDetails.ContactNo')}
                                fullWidth
                            />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <MpgFileUpload
                                name="profileImg"
                                label={fetchAdminAccountTeamDetailsLabel('AccountTeamMemberDetails.ProfilePic')}
                                rhfFormInstance={rhfFormInstance}
                                persistantMsg={fetchAdminAccountTeamDetailsLabel('AccountTeamMemberDetails.MaxSizeAllowedMessage')}
                            />
                        </Grid>
                    </Grid>
                </Item>
                <br />
                <Item>
                    <Stack
                        direction={{ xs: "column", sm: "row" }}
                        justifyContent="space-between"
                        alignItems="center"
                    >
                        <Typography variant="h6" align='center' sx={{ fontWeight: 'bolder' }}>
                         {adminAccountTeamCMSData?.pageContent["BioDetailListComponent"]?.Title}
                        </Typography>
                        <Button
                            variant="outlined"
                            size="small"
                            onClick={() => setOpen(true)}
                        >{adminAccountTeamCMSData?.pageContent["BioDetailsComponent"]?.Title}
                        </Button>
                    </Stack>
                    <BioTable
                        tableData={bioDetailTableData}
                        setTableData={setBioDetailTableData}
                        setBioDetailObjToBeEdited={setBioDetailObjToBeEdited}
                        setOpenEditBioDialog={setOpenEditBioDialog}
                        cmsData={adminAccountTeamCMSData && adminAccountTeamCMSData}
                    />
                </Item>


                <Stack
                    direction={{ xs: "column", sm: "row" }}
                    justifyContent={"space-evenly"}
                    mt={3}
                >
                    <Button
                        variant='contained'
                        size="small"
                        type='submit'
                    >
                        {fetchAdminAccountTeamDetailsLabel('AccountTeamMemberDetails.CreateMember')}
                    </Button>
                </Stack>
            </Box >

            {/**Bio Dialog */}
            { < AddBioDialog
                open={open}
                setOpen={setOpen}
                bioDetailTableData={bioDetailTableData}
                setBioDetailTableData={setBioDetailTableData}
                cmsData={adminAccountTeamCMSData && adminAccountTeamCMSData}
            />}

            {
                !!bioDetailObjToBeEdited && bioDetailObjToBeEdited?.Id && (
                    <EditBioDialog
                        open={openEditBioDialog}
                        setOpen={setOpenEditBioDialog}
                        bioDetailTableData={bioDetailTableData}
                        setBioDetailTableData={setBioDetailTableData}
                        bioDetailObjToBeEdited={bioDetailObjToBeEdited}
                        cmsData={adminAccountTeamCMSData && adminAccountTeamCMSData}
                    />
                )
            }

            {/** error dialog on create action */}
            <MpgErrorDialog
                open={!!isErrorOnCreate}
                title={`${!!isErrorOnCreate && errorOnCreate?.response?.data === "EmailExists" ? "Email exists. Try again...!" : ""}`}

                content={`${!!isErrorOnCreate && errorOnCreate?.response?.data === "EmailExists" ? `"${watch('email')}" exists already in our records. Please, try again with different email id.` : ""}`}
            />
            <MpgLoadingDialog
                open={
                    !!isLoadingOnCreate ||
                    !!isLoadingOnProfilePicUpload
                }
            />
        </Box >
    )
}

export default CreateAccountTeamMembers;